import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  button: {
    textDecoration: 'underline',
    fontWeight: '500',
    marginTop: spacing(16),
  },
  select: {
    minWidth: '500px',
  },
  modal: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '560px',
  },
  filter: {
    marginBottom: '25px',
  },
  error: {
    marginTop: '5px',
    fontSize: '12px',
    color: 'red',
  },
  label: {
    marginBottom: '12px',
    fontSize: Theme.Typography.FontSize.XXSmall,
    color: Theme.Colors.Grayscale.ThirtyTwo,
  },
  loader: {
    minWidth: '500px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))
